document.addEventListener("DOMContentLoaded", () => {
  const addOneTimeBtn = document.getElementById("add-bundle-onetime");
  const addSubBtn = document.getElementById("add-bundle-subscription");

  const oneTimeSection = document.querySelector(".one-time-bundle");
  const subscriptionSection = document.querySelector(".subscription-bundle");

  if (!addOneTimeBtn || !addSubBtn) return;

  let rafId = null;

  function getCurrentPurchaseType() {
    return (
      document.querySelector(".purchase-type.active")?.dataset.type ||
      document.querySelector("[data-type].active")?.dataset.type ||
      "subscription"
    );
  }

  function getActiveBundleGroup(sectionEl) {
    if (!sectionEl) return null;

    return (
      sectionEl.querySelector(".bundle-group.active:not(.hidden)") ||
      sectionEl.querySelector(".bundle-group.active") ||
      sectionEl.querySelector(".bundle-group:not(.hidden)")
    );
  }

  function areAllSlotsFilled(groupEl) {
    if (!groupEl) return false;

    const slots = groupEl.querySelectorAll(".bundle-product");
    if (!slots.length) return false;

    return Array.from(slots).every((slot) => {
      const variantId = slot.dataset.id || "";
      const productId = slot.dataset.product || "";

      return variantId.trim() !== "" && productId.trim() !== "";
    });
  }

  function cacheDefaultAtcText(button) {
    const textSpan = button.querySelector("[data-atc-text]");
    if (!textSpan) return;

    if (!textSpan.dataset.defaultAtcText) {
      textSpan.dataset.defaultAtcText = textSpan.textContent.trim();
    }
  }

  function updateButtonText(button, isComplete) {
    const textSpan = button.querySelector("[data-atc-text]");
    if (!textSpan) return;

    cacheDefaultAtcText(button);

    const defaultText = textSpan.dataset.defaultAtcText || "";
    const incompleteText =
      textSpan.getAttribute("data-atc-text") || defaultText;

    textSpan.textContent = isComplete ? defaultText : incompleteText;
  }

  function updateButtonState(button, isComplete) {
    button.disabled = false;

    button.classList.toggle("is-bundle-incomplete", !isComplete);
    button.classList.toggle("is-bundle-complete", isComplete);

    updateButtonText(button, isComplete);
  }

  function updateBundleButtons() {
    rafId = null;

    const purchaseType = getCurrentPurchaseType();

    const oneTimeGroup = getActiveBundleGroup(oneTimeSection);
    const subscriptionGroup = getActiveBundleGroup(subscriptionSection);

    const oneTimeComplete =
      purchaseType === "one-time" && areAllSlotsFilled(oneTimeGroup);

    const subscriptionComplete =
      purchaseType === "subscription" && areAllSlotsFilled(subscriptionGroup);

    updateButtonState(addOneTimeBtn, oneTimeComplete);
    updateButtonState(addSubBtn, subscriptionComplete);
  }

  function scheduleBundleButtonCheck() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(updateBundleButtons);
  }

  document.addEventListener("click", (e) => {
    if (
      e.target.closest(".purchase-type") ||
      e.target.closest("[data-type]") ||
      e.target.closest(".bundle-option") ||
      e.target.closest("[data-target]") ||
      e.target.closest(".bundle-product") ||
      e.target.closest("[data-popup-trigger]") ||
      e.target.closest(".add-btn") ||
      e.target.closest(".bundle-collection__image") ||
      e.target.closest(".quickview__select") ||
      e.target.closest(".remove-btn") ||
      e.target.closest(".bundle-popup__selected-remove")
    ) {
      scheduleBundleButtonCheck();
    }
  });

  const observerTargets = [oneTimeSection, subscriptionSection].filter(Boolean);

  observerTargets.forEach((target) => {
    const observer = new MutationObserver((mutations) => {
      const shouldCheck = mutations.some((mutation) => {
        return (
          mutation.type === "childList" ||
          mutation.attributeName === "data-id" ||
          mutation.attributeName === "data-product" ||
          mutation.attributeName === "class"
        );
      });

      if (shouldCheck) {
        scheduleBundleButtonCheck();
      }
    });

    observer.observe(target, {
      attributes: true,
      subtree: true,
      childList: true,
      attributeFilter: ["class", "data-id", "data-product"],
    });
  });

  cacheDefaultAtcText(addOneTimeBtn);
  cacheDefaultAtcText(addSubBtn);

  addOneTimeBtn.disabled = false;
  addSubBtn.disabled = false;

  scheduleBundleButtonCheck();

  window.bundleButtons_checkSlots = scheduleBundleButtonCheck;
});
